import React from "react";

import { FormattedMessage } from "react-intl";

import { CrimesFormSchema } from "./CrimesForm.schema";

const renderCrimeItem = item => {
  const { name, type } = item;

  return [name, type].join(" - ");
};

export const getCrimesFormConfig = (
  { crimesData, onSearchCrime },
  { courtsData, onSearchCourt }
) => [
  {
    label: <FormattedMessage id="title_crime" />,
    fieldType: "autocomplete",
    name: "crime",
    options: crimesData,
    optionField: "name",
    placeholder: "search_text",
    completeMethod: onSearchCrime,
    validation: CrimesFormSchema.fields["crime"],
    renderItem: renderCrimeItem,
    renderSelectedItem: renderCrimeItem,
  },
  {
    label: <FormattedMessage id="title_case_number" />,
    fieldType: "text",
    name: "crime_case_number",
    placeholder: "placeholder_number",
    validation: CrimesFormSchema.fields["crime_case_number"],
  },
  {
    label: <FormattedMessage id="label_crime_verdict_date" />,
    fieldType: "calendar",
    name: "crime_verdict_date",
    validation: CrimesFormSchema.fields["crime_verdict_date"],
  },
  {
    label: <FormattedMessage id="label_court_name" />,
    fieldType: "autocomplete",
    name: "court",
    options: courtsData,
    optionField: "court_name",
    placeholder: "search_text",
    completeMethod: onSearchCourt,
    validation: CrimesFormSchema.fields["court"],
  },
  {
    label: <FormattedMessage id="message_penalty" />,
    fieldType: "text",
    name: "crime_sentence",
    placeholder: "placeholder_crime_sentence",
    validation: CrimesFormSchema.fields["crime_sentence"],
  },
];

export const parseInitialData = data => {
  if (!data) {
    return {
      crime: null,
      crime_case_number: "",
      crime_verdict_date: "",
      court: null,
      crime_sentence: "",
    };
  }

  return {
    crime: {
      name: data.crime_name,
      type: data.crime_case_type,
    },
    crime_case_number: data.crime_case_number,
    crime_verdict_date: data.crime_verdict_date,
    court: {
      court_name: data.crime_court_name ?? data.crime_court,
    },
    crime_sentence: data.crime_sentence,
  };
};
